import {DEFAULT_LANGUAGE} from "../i18n/config";

export interface StringTranslations {
  readonly [languageCode: string]: string;
}

export const getValueWithFallback = (
  translations: StringTranslations | undefined,
  currentLanguage: string,
  defaultLanguage: string = DEFAULT_LANGUAGE
): string => {
  if (!translations || Object.keys(translations).length === 0) {
    return '';
  }

  // Try current language
  if (translations[currentLanguage]) {
    return translations[currentLanguage];
  }

  // Try default language
  if (translations[defaultLanguage]) {
    return translations[defaultLanguage];
  }

  // Return first available translation
  const firstKey = Object.keys(translations)[0];
  return translations[firstKey] || '';
};

/**
 * Create StringTranslations with only default language value
 */
export const ofDefault = (value: string, defaultLanguage: string = DEFAULT_LANGUAGE): StringTranslations => {
  return {
    [defaultLanguage]: value
  };
};

/**
 * Get the value for a specific language or empty string if not found
 */
export const getValue = (
  translations: StringTranslations | undefined,
  language: string
): string => {
  return translations?.[language] || '';
};

/**
 * Set the value for a specific language
 */
export const setValue = (
  translations: StringTranslations,
  language: string,
  value: string
): StringTranslations => {
  return {
    ...translations,
    [language]: value
  };
};

/**
 * Check if translations exist for a specific language
 */
export const hasTranslation = (
  translations: StringTranslations | undefined,
  language: string
): boolean => {
  return !!translations?.[language];
};

/**
 * Get list of languages that have translations
 */
export const getTranslatedLanguages = (
  translations: StringTranslations | undefined
): string[] => {
  return translations ? Object.keys(translations).filter(key => !!translations[key]) : [];
};

